import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import queryString from 'query-string'

import { LayoutPlain, Header, Footer } from 'components/layout'
import { apiDashboard } from 'helpers/decorators/api'

@apiDashboard.apiPersons()
class ConfirmLoginChange extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    onLoginChange: PropTypes.func.isRequired
  }

  componentDidMount() {
    const query = queryString.parse(get(this.props, 'location.search'))
    const personId = get(query, 'personId')
    const authorizationCode = get(query, 'authorizationCode')

    if (personId && authorizationCode
    ) {
      this.props.onLoginChange({
        personId,
        code: authorizationCode,
        isConfirm: true
      })
    }
  }

  render() {
    const content = (
      <h1 className="beta text--center">
        <FormattedMessage
          id="moduleTitle.confirming_email_address"
          defaultMessage="Confirming email address ..."
        />
      </h1>
    )

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[content]}
        colWidth="320px"
      />
    )
  }
}

export default ConfirmLoginChange
